import React from 'react';
import { NineCellLoading } from 'react-loadingg';

const qs = require('querystring');

export default class OnlineLesson extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        const parsed = qs.parse(window.location.hash);
        this.link = parsed['#/app/lesson?link'];
        this.setState({ isLoading: false, link: this.link });
    }

    render() {

        if (this.state.isLoading) return <NineCellLoading />;
        else return(
            <iframe src={this.state.link}></iframe>
        );
    }
}